// extracted by mini-css-extract-plugin
module.exports = {"Main":"OffSiteOnHandItem_Main__1_9wm","Details":"OffSiteOnHandItem_Details__9sO-R"};